import {Fragment, h} from "preact";
import {useAppContext} from "../../../../../contexts";
import s from "./emptyCart.module.css";
import {iconWarning} from "../../../../../assets";

const EmptyCart = () => {
    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Fragment>
            <div className={s.warningContainer}>
                <img
                    src={iconWarning}
                    alt={"Warning icon"}
                    data-testid="content-image"
                    className={`select-none ${highContrast ? "highImage" : ""}`}
                />
                <p data-testid="content-label" className={`${highContrast ? "highTitleFirst" : ""}`}>
                    Seu carrinho está vazio.
                </p>
            </div>
        </Fragment>
    )
}

export default EmptyCart;
